/** 12-column grid: 4 fields per row on md+ */
export const MUNICIPALITY_GRID_FIELD_COL = 'col-12 md:col-3 mb-2 min-w-0';

export const MUNICIPALITY_API_BASE = '/municipality-registrations';

export const FEE_TYPE = {
  PERMIT_FEE: 'Permit Fee',
  PERMIT_FORMULA: 'Permit Formula',
} as const;
